<template>
  <div id="app">
    <AppHeader v-if="!hideLayout" />
    <router-view />
    <AppFooter v-if="!hideLayout" />
  </div>
</template>

<script>
import AppHeader from './components/AppHeader.vue'
import AppFooter from './components/AppFooter.vue'

export default {
  name: 'App',
  components: { AppHeader, AppFooter },
  computed: {
    hideLayout() {
      return this.$route.meta && this.$route.meta.hideLayout
    }
  }
}
</script>

<style>
* { margin: 0; padding: 0; box-sizing: border-box; }
body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', Arial, sans-serif; color: #333; background: #fff; }
</style>
